import React from "react";

import HeaderView from "../rows/header";

export const Header = () => <HeaderView />;
